import React from "react";

import { observer } from "mobx-react";
import PrematchOfferMenuStore from "@state/stores/offer/prematch/PrematchOfferMenuStore";

import { TournamentItem } from ".";

export const TournamentItems = observer(function TournamentItems(props: {
	store: Parameters<typeof TournamentItem>[0]["store"];
	sport: PrematchOfferMenuStore["menu"];
	category: PrematchOfferMenuStore["menu"];
}) {
	if (props.category.children == null || !props.category.isExpanded) {
		return null;
	}

	return (
		<ul className="nav--quaternary">
			{props.category.children.map((tournament) => (
				<TournamentItem
					key={tournament.node.id}
					tournament={tournament}
					category={props.category}
					sport={props.sport}
					store={props.store}
				/>
			))}
		</ul>
	);
});
